import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-578">
      <Navbar data-id="element-579" />
      <main className="pt-32 pb-24" data-id="element-580">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-581">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-582">
            Terms and Conditions
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-583">
            <p className="font-medium" data-id="element-584">Last updated: 14 December 2025</p>

            <p data-id="element-585">
              These Terms and Conditions form part of, and must be read in
              conjunction with, the Website and Mobile Application Terms and
              Conditions. KittyPot Ltd reserves the right to modify these Terms
              at any time.
            </p>

            <p data-id="element-586">
              The information provided on this website is for general
              information purposes only. This content is provided by
              https://kittypot.com (the "Website") and the KittyPot mobile
              application (the "Mobile Application"), together referred to as
              "KittyPot Ltd", "we", "us", or "our".
            </p>

            <p data-id="element-587">
              By using this Website and/or Mobile Application, you agree to the
              following:
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-588">
              1. Waitlist Sign-Up
            </h2>
            <p data-id="element-589">
              By submitting your name and email address, you are joining the
              KittyPot waitlist to receive updates and notifications about our
              upcoming mobile application. You consent to receive email
              communications related to your waitlist status and relevant
              product updates. You may unsubscribe at any time.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-590">
              2. Contact Page
            </h2>
            <p data-id="element-591">
              You may use our contact form to reach out with questions,
              feedback, or enquiries. By submitting a message, you consent to us
              using the information provided solely to respond to your request.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-592">
              3. Accuracy of Information
            </h2>
            <p data-id="element-593">
              We do not guarantee the accuracy, completeness, or timeliness of
              information provided on the Website or Mobile Application. Any
              reliance you place on such information is strictly at your own
              risk.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-594">
              4. Limitation of Liability
            </h2>
            <p data-id="element-595">
              To the fullest extent permitted by law, KittyPot Ltd shall not be
              liable for any direct, indirect, incidental, consequential, or
              special damages arising from your use of the Website or Mobile
              Application, including but not limited to loss of data, financial
              loss, or service interruption.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-596">
              5. General Terms
            </h2>
            <p data-id="element-597">
              The Website and Mobile Application are provided on an "as is" and
              "as available" basis. We do not guarantee uninterrupted access,
              error-free operation, or that our services will always be secure
              or available.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-598">
              6. No Warranties
            </h2>
            <p data-id="element-599">
              KittyPot Ltd expressly disclaims all warranties, whether express
              or implied, including but not limited to:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-600">
              <li data-id="element-601">
                Implied warranties of merchantability or fitness for a
                particular purpose
              </li>
              <li data-id="element-602">Non-infringement or quiet enjoyment</li>
              <li data-id="element-603">
                Any warranties arising from usage, trade, or course of dealing
              </li>
            </ul>
            <p data-id="element-604">
              You use our services at your own risk. It is your responsibility
              to ensure you maintain backups of any data you provide.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-605">
              7. No Guarantee of Accuracy
            </h2>
            <p data-id="element-606">
              We do not warrant that any information, recommendations, or
              content provided through our services is accurate, complete, or
              current, and we disclaim liability for any errors or omissions.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-607">
              8. Third-Party Services
            </h2>
            <p data-id="element-608">
              KittyPot Ltd makes no representations or warranties regarding any
              third-party services, tools, or advice that may be referenced or
              integrated into our services.
            </p>
            <p data-id="element-609">
              We aim to keep the Website and Mobile Application running
              smoothly, however KittyPot Ltd will not be liable for temporary
              unavailability due to technical issues beyond our reasonable
              control.
            </p>

            <p className="mt-8" data-id="element-610">
              If you have questions about these Terms, please contact us via our
              online contact form.
            </p>

            <hr className="border-gray-200 my-12" data-id="element-611" />

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-612">
              Competition Entry Disclosure
            </h2>
            <p data-id="element-613">
              From time to time, KittyPot Ltd may run promotional competitions.
              Participation is subject to the following conditions:
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-614">
              1. Eligibility
            </h3>
            <p data-id="element-615">
              Competitions are open only to residents of the United Kingdom who
              are aged 18 or over at the time of entry.
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-616">
              2. Prize Distribution
            </h3>
            <p data-id="element-617">
              Any prizes awarded will be distributed exclusively through the
              KittyPot mobile application, once available. Winners must have
              access to the App to claim their prize.
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-618">
              3. Prize Allocation
            </h3>
            <p data-id="element-619">
              Unless stated otherwise, only one prize will be awarded per
              competition. Full details of prizes and distribution will be
              communicated separately.
            </p>

            <p className="mt-8" data-id="element-620">
              By entering a competition, you confirm that you meet the
              eligibility requirements and agree to all applicable terms and
              conditions.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-621" />
    </div>;
}